import React, {useState} from 'react';

import {ItemWithChildrenStructure} from 'app/general/structures/ItemWithChildrenStructure';
import {gt} from 'app/utils/i18n';

import {KBTreeEditCategory} from './KBTreeEditCategory';

import {KBTreeItemInnerButton, KBTreeItemInnerDiv} from '../KBTreeStructures';

import {KnowledgebaseSerializedType} from 'sweet-types';

type Props = {
  kb: KnowledgebaseSerializedType;
  parentCategoryURL: null | string;
  afterAction?: () => any;
};
export const KBTreeCreateCategoryItem = ({
  kb,
  parentCategoryURL,
  afterAction,
}: Props) => {
  const [editing, setEditing] = useState<boolean>(false);

  function disableEditing() {
    setEditing(false);
    if (afterAction != null) {
      afterAction();
    }
  }

  return (
    <ItemWithChildrenStructure>
      {editing ? (
        <KBTreeItemInnerDiv
          toggleableIcon={<i className="fas fa-plus-circle" />}
          className="p-0"
        >
          <KBTreeEditCategory
            kb={kb}
            parentCategoryURL={parentCategoryURL}
            afterAction={disableEditing}
            onCancel={() => setEditing(false)}
          />
        </KBTreeItemInnerDiv>
      ) : (
        <KBTreeItemInnerButton
          className="btn-link btn-sm"
          itemIcon={<i className="fas fa-plus-circle" />}
          onClick={() => setEditing(true)}
        >
          {gt('Add new Category')}
        </KBTreeItemInnerButton>
      )}
    </ItemWithChildrenStructure>
  );
};
